import { DEFAULT_STATE } from '../constants'

export const initialCommunityGalleryFiltersState = {
  communityGalleryFilters: { ...DEFAULT_STATE.communityGalleryFilters },
}
